var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('page-header',{attrs:{"page-name":"植烟环境","icon":"el-icon-menu"}})],1),_c('head-check-environment')],1)}
var staticRenderFns = []

export { render, staticRenderFns }